import { useMutation, useQueryClient } from "react-query";

import FamilyService from "../../services/Family";

import { QUERY_KEY } from "./useListFamilies";

function useCreateFamily() {
  const queryClient = useQueryClient();

  return useMutation(FamilyService.createFamily, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY);
    },
  });
}

export default useCreateFamily;
